import { useTranslation } from "react-i18next";
import { Button, Icon } from "@atoms";
import { Badge } from "@shadcn";
import { Check } from "lucide-react";
import { SubscriptionPlansTypes } from "../../../../types";


export type SubscriptionCardTemplateProps = {
  planType: SubscriptionPlansTypes;
  planAmount: number;
  subscriptionPlanData: any;
  onClick: () => void;
  onSendEmail: () => void;
};

export const SubscriptionCardTemplate = ({
  planType,
  planAmount,
  subscriptionPlanData,
  onClick,
  onSendEmail
}: SubscriptionCardTemplateProps): JSX.Element => {
  const { t } = useTranslation();
  const pointKeys = subscriptionPlanData?.pointKeys ?? subscriptionPlanData?.points ?? [];
  
  let planAmountText = "";
  if (planAmount !== undefined && planAmount !== null && planAmount !== 0) {
    planAmountText = `$${(planAmount / 100).toFixed(2)}`;
  }

  const planLabel =
    planType === SubscriptionPlansTypes.enterprise
      ? t("billing.subscription.planLabel.enterprise")
      : t("billing.subscription.planLabel.basic");
  const planName =
    planType === SubscriptionPlansTypes.enterprise
      ? t("billing.subscription.planName.enterprise")
      : t("billing.subscription.planName.basic");
 
  return (
    <div>
      <div className="flex flex-col h-full w-full border border-neutral-light rounded-2xl bg-white p-6">
        <div className="flex items-start justify-between pb-3 pt-1">
          <div>
            <div className="text-neutral-dark text-xl font-semibold">
              {t("billing.subscription.yourPlan")}
            </div>
            <div className="metric-subtitle">
              {planName}
            </div>
          </div>
          <div className="w-24 flex justify-end">
            <Badge
              variant="outline"
              className="inline-flex items-center gap-2 rounded-full px-2.5 py-1 text-xs font-medium bg-white border-green-200 text-green-700"
            >
              <span className="flex items-center justify-center rounded-full bg-green-500 text-white h-3 w-3">
                <Check className="h-1.5 w-1.5" />
              </span>
              <span>{planLabel}</span>
            </Badge>
          </div>
        </div>
        <div className="flex flex-row items-end h-8">
          <div className="font-medium text-3xl text-neutral-darkest leading-8">{planAmountText !== "" ? planAmountText : "$5.00"}</div>
          <div className="font-normal text-base text-neutral-darkest pl-1">{t("billing.subscription.perMonth")}</div>
        </div>
        <div className="border-b border-neutral-light pt-4"></div>
        <div className="font-semibold text-sm text-neutral-darkest pt-5">{t("billing.subscription.includes")}</div>
        <div className={" pb-1"}>
          {pointKeys.map((pointKey: string, index: number) => 
            <div className="pt-3 flex flex-row items-center" key={index}>
              <div>
                <Icon variant={"checkCircleFilled"} size={15} />
              </div>
              <div className="font-normal text-sm text-neutral-darkest pl-2">{t(pointKey)}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
